<button class="btn btn-link" type="button" (click)="openModal()">
  <i class="fa fa-plus" aria-hidden="true"></i>
  <span>
    {{ "BUTTON.ADD_OTHER_DOCUMENT" | translate }}
  </span>
</button>
<custom-modal
  [open]="isModalOpen"
  (openChange)="openChange($event)"
  [header]="'BUTTON.ADD_OTHER_DOCUMENT'"
  [modalClass]="'modal-body-initial'"
>
  <div>
    <div id="bodyContent">
      <form>
        <div *ngFor="let config of formConfig; let last = last" [ngClass]="{ 'mb-3': !last }">
          <app-radio-button [control]="control" [id]="config.id" [value]="config.value" [label]="config.label"></app-radio-button>
        </div>
      </form>
    </div>
    <loading-spinner *ngIf="isLoading" [show]="isLoading"></loading-spinner>
  </div>
  <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
  <button footer-action type="button" class="btn btn-secondary" (click)="onAddOtherDocument()">
    {{ "BUTTON.ADD" | translate }}
  </button>
</custom-modal>
<input
  #input
  [id]="id"
  (click)="clickInput()"
  [accept]="ALLOWED_FILE_MIMES.join(',')"
  class="d-none"
  type="file"
  (change)="handleFiles($event)"
/>
